import { type ScoringType, type BandRow, type CriterionKey } from "./types";
import { getCriterionKey, CRITERION_REGISTRY } from "./criterionRegistry";

export function getBandRows(c: ScoringType): BandRow[] {
  const key = getCriterionKey(c);
  if (!key) return [];
  const entry = CRITERION_REGISTRY[key];
  if (!entry) return [];
  const bands = (c[key] as unknown[]) ?? [];
  return bands
    .map((b) => ({
      summary: entry.getBandSummary(b),
      score: (b as { score: number }).score,
    }))
    .filter((row) => row.summary !== "—");
}

// ── Generated profile utilities ──────────────────────────────────────────

/**
 * Transforms the Scoring API response into ScoringType[] suitable for
 * the ScoringProfileDialog. Sorts bands by score descending and sets
 * each criterion's weight to its max band score.
 */
export function transformGeneratedProfile(
  rawCriteria: ScoringType[]
): ScoringType[] {
  return rawCriteria
    .filter((c) => getCriterionKey(c) !== null)
    .map((criterion) => {
      const key = getCriterionKey(criterion)!;
      const bands = criterion[key] as Array<{ score: number }> | undefined;
      if (bands && bands.length > 0) {
        bands.sort((a, b) => b.score - a.score);
        criterion.weight = bands[0].score;
      }
      return criterion;
    });
}

/**
 * Checks if any generated criterion has empty band data.
 * Returns true if the profile has empty criteria.
 */
export function isEmptyScoringTypeReturned(criteria: ScoringType[]): boolean {
  return criteria.some((c) => {
    const key = getCriterionKey(c) as CriterionKey | null;
    if (!key) return true;
    const bands = c[key];
    return !bands || (Array.isArray(bands) && bands.length === 0);
  });
}
